// @flow
import React, {useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import {Collapse, Divider} from '@material-ui/core';
import {colors} from '../../../../assets/styles/colors';

const useStyles = makeStyles(theme => ({
  accordion: {
    display: 'flex',
    width: '100%',
  },
  accordionTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer',
    alignItems: 'center',
  },
  accordionItem: {
    width: '100%',
    padding: theme.spacing(2),
    margin: theme.spacing(1, 0, 0, 0),
    background: '#FFFFFF',
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.17)',
    borderRadius: '12px',
  },
  accordionContent: {
    marginTop: theme.spacing(1),
    paddingTop: theme.spacing(2),
  },
  title: {
    color: `${colors.grey900}`,
    fontWeight: 500,
    fontSize: '16px',
  },
  divider: {
    background: colors.grey300,
    marginTop: theme.spacing(2),
  },
}));

type Props = {|
  title?: string,
  content: any,
|};

export default function ButtonAccordion(props: Props) {
  const {title, content} = props;
  const classes = useStyles();
  const [isActive, setIsActive] = useState(false);

  return (
    <div className={classes.accordion}>
      <div className={classes.accordionItem}>
        <div
          className={classes.accordionTitle}
          onClick={() => setIsActive(!isActive)}
        >
          <div className={classes.title}>{title}</div>
          <div>{isActive ? <ExpandLessIcon /> : <ExpandMoreIcon />}</div>
        </div>
        <Collapse in={isActive}>
          <Divider className={classes.divider} />
          <div className={classes.accordionContent}>{content}</div>
        </Collapse>
      </div>
    </div>
  );
}

ButtonAccordion.propTypes = {
  title: PropTypes.string,
  content: PropTypes.node.isRequired,
};
